import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/board/pop_close.png'


const _withScopeId = n => (_pushScopeId("data-v-82602c80"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "pop_content" }
const _hoisted_5 = { class: "pop_content_box" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "pop_content_box"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "pop_content_box"
}
const _hoisted_12 = { class: "pop_img_header" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "이미지", -1))
const _hoisted_14 = { class: "pop_img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 2,
  class: "pop_content_box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal_bg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fnEvent(false)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "pop_layer pop_white",
      id: "pop1",
      style: _normalizeStyle({ display: $setup.props.show ? 'block' : 'none' })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["pop_hd", $props.title ? '' : 'no_title'])
      }, [
        _createElementVNode("span", { innerHTML: $props.title }, null, 8, _hoisted_1),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.fnEvent(false)))
        }, _hoisted_3)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        ($setup.props.content?.main?.data !== '')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_5, [
                ($props.content.title)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($props.content?.title), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: _normalizeClass([$props.content?.main.class]),
                  innerHTML: $setup.fnRender($props.content.main.data, $props.content.main)
                }, null, 10, _hoisted_7)
              ]),
              ($setup.props.content?.subTitle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString($props.content?.subTitle), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass([$props.content?.sub?.class]),
                      innerHTML: $setup.fnRender($props.content?.sub?.data, $props.content?.sub)
                    }, null, 10, _hoisted_10)
                  ]))
                : _createCommentVNode("", true),
              ($setup.props.content?.img?.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.downloadImg($props.content.img)))
                      }, "다운로드")
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        class: _normalizeClass(["pop_img", { blur: $props.content.img.data }]),
                        src: $props.content.img.data,
                        alt: ""
                      }, null, 10, _hoisted_15)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : ($setup.props.content.img)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: _normalizeClass(["pop_img", { blur: $props.content.img.data }]),
                src: $props.content.img.data,
                alt: ""
              }, null, 10, _hoisted_16))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_Loading, {
                  isLoading: true,
                  class: "pop_spinner"
                })
              ]))
      ])
    ], 4)
  ], 64))
}